import api from "../../../utils/api";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import { GET_CLIENT_PERMISSION, GET_CLIENT_PERMISSION_ERROR, SAVE_CLIENT_PERMISSION, SAVE_CLIENT_PERMISSION_ERROR } from "../types";

export const save_client_permission = (permission) => async (dispatch) => {
    try {
        const res = await api.post('api/client/save-permissions', permission);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_CLIENT_PERMISSION,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_CLIENT_PERMISSION_ERROR })
        return false;
    }
}

export const get_client_permission = () => async (dispatch) => {
    try {
        const res = await api.get('api/client/get-permissions');
        dispatch({
            type: GET_CLIENT_PERMISSION,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: GET_CLIENT_PERMISSION_ERROR })
        return false;
    }
}